// Verwaltungskonten (Z3): reine Hilfen für Liste, Filter, Knöpfe und Verlauf. Keine Importe.
const ZONE = 'Europe/Berlin';

function teile(iso) {
  if (!iso) return null;
  const d = iso instanceof Date ? iso : new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const t = {};
  new Intl.DateTimeFormat('de-DE', { timeZone: ZONE, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
    .formatToParts(d).forEach((p) => { t[p.type] = p.value; });
  return t;
}

export function datumKurz(iso) {
  const t = teile(iso);
  return t ? `${t.day}.${t.month}.${t.year}` : '';
}

export function datumMitUhrzeit(iso) {
  const t = teile(iso);
  return t ? `${t.day}.${t.month}.${t.year}, ${t.hour}:${t.minute} Uhr` : '';
}

// Ganze Kalendertage in deutscher Zeit (23:50 gestern ist „gestern“).
export function tageZurueck(iso, jetzt) {
  const a = teile(iso);
  const b = teile(jetzt);
  if (!a || !b) return null;
  const tag = (t) => Date.UTC(Number(t.year), Number(t.month) - 1, Number(t.day)) / 86400000;
  return tag(b) - tag(a);
}

// Nur der Tag, nie eine Uhrzeit (Datenschutz: nur Nachweis „hat Zugang“).
export function letzteAnmeldungText(iso, jetzt, keinZugangDringend) {
  const tage = tageZurueck(iso, jetzt);
  if (tage === null) return keinZugangDringend === true ? 'noch nie' : 'nicht erfasst';
  if (tage <= 0) return 'heute';
  if (tage === 1) return 'gestern';
  return `vor ${tage} Tagen`;
}

export const istArchiviert = (u) => Boolean(u) && u.is_active === false;
export const istGesperrt = (u) => Boolean(u && u.gesperrt);

export function kontoStatus(u) {
  if (istArchiviert(u)) return 'archiviert';
  if (istGesperrt(u)) return 'gesperrt';
  return 'aktiv';
}

export function passtZusatzfilter(u, filter) {
  if (filter === 'gesperrt') return istGesperrt(u) && !istArchiviert(u);
  if (filter === 'ohne2fa') return !istArchiviert(u) && !istGesperrt(u) && !u.zwei_faktor_aktiv;
  return true;
}

export function zusatzAnzahlen(liste) {
  const l = liste || [];
  return {
    gesperrt: l.filter((u) => passtZusatzfilter(u, 'gesperrt')).length,
    ohne2fa: l.filter((u) => passtZusatzfilter(u, 'ohne2fa')).length,
  };
}

export const MENUE_TEXTE = {
  passwort: 'Passwort zurücksetzen (Link oder Zugangscode)',
  sitzungen: 'Auf allen Geräten abmelden',
  zweifaktor: '2FA zurücksetzen',
  archivieren: 'Archivieren',
  loeschen: 'Endgültig löschen',
};

// Welche Knöpfe und Menüeinträge es für ein Konto gibt (ich = angemeldetes Konto).
export function kontoAktionen(u, ich) {
  if (u.id === (ich && ich.id)) return { knoepfe: ['bearbeiten'], menue: [] };
  if (u.role === 'admin' && ich && ich.role === 'geschaeftsfuehrung') return { knoepfe: [], menue: [] };
  if (istArchiviert(u)) return { knoepfe: ['wiederherstellen'], menue: [{ key: 'loeschen' }] };
  // Handy verloren: sperren → 2FA zurücksetzen → entsperren (Backend erlaubt das Zurücksetzen auch gesperrt).
  if (istGesperrt(u)) {
    return {
      knoepfe: ['bearbeiten', 'entsperren'],
      menue: [{ key: 'passwort', deaktiviert: true, hinweis: 'Erst entsperren' },
        ...(u.zwei_faktor_aktiv ? [{ key: 'zweifaktor' }] : []), { trenner: true }, { key: 'archivieren' }],
    };
  }
  const menue = [{ key: 'passwort' }, { key: 'sitzungen' }];
  if (u.zwei_faktor_aktiv) menue.push({ key: 'zweifaktor' });
  menue.push({ trenner: true }, { key: 'archivieren' });
  return { knoepfe: ['bearbeiten', 'sperren'], menue };
}

export const VERLAUF_TEXTE = {
  eingeladen: 'Eingeladen',
  link_gesendet: 'Link zum Passwort-Zurücksetzen gesendet',
  zugangscode_erzeugt: 'Zugangscode erzeugt',
  passwort_per_link_festgelegt: 'Passwort über den Link festgelegt',
  passwort_per_code_festgelegt: 'Passwort mit Zugangscode festgelegt',
  passwort_geaendert: 'Passwort geändert',
  sitzungen_beendet: 'Auf allen Geräten abgemeldet',
  rolle_geaendert: 'Rolle geändert',
  email_geaendert: 'E-Mail-Adresse geändert',
  gesperrt: 'Konto gesperrt',
  entsperrt: 'Konto entsperrt',
  anmeldung_abgelehnt_gesperrt: 'Anmeldung abgelehnt – Konto gesperrt',
  archiviert: 'Konto archiviert',
  wiederhergestellt: 'Konto wiederhergestellt',
  '2fa_eingerichtet': '2FA eingerichtet',
  '2fa_neu_eingerichtet': '2FA neu eingerichtet',
  '2fa_zurueckgesetzt': '2FA zurückgesetzt',
  '2fa_codes_erneuert': 'Neue Wiederherstellungscodes',
  '2fa_wiederherstellungscode_benutzt': 'Mit Wiederherstellungscode angemeldet',
  '2fa_zu_viele_fehlversuche': 'Zu viele falsche Zwei-Faktor-Codes',
};
export const VERLAUF_UNBEKANNT = 'Änderung am Konto';
const ROT = ['anmeldung_abgelehnt_gesperrt', '2fa_zu_viele_fehlversuche'];

function verlaufDetail(e, rollenNamen) {
  if (e.action === 'gesperrt' || e.action === '2fa_zurueckgesetzt') return e.detail || '';
  if (e.action === 'rolle_geaendert' && e.detail) {
    return String(e.detail).split(' → ').map((k) => (rollenNamen && rollenNamen[k]) || k).join(' → ');
  }
  return '';
}

export function verlaufEintraege(events, rollenNamen) {
  const zeit = (e) => { const t = Date.parse(e.created_at || ''); return Number.isNaN(t) ? 0 : t; };
  return [...(events || [])].sort((a, b) => zeit(b) - zeit(a)).slice(0, 10).map((e) => {
    const rot = ROT.includes(e.action);
    return {
      text: VERLAUF_TEXTE[e.action] || VERLAUF_UNBEKANNT,
      wann: datumMitUhrzeit(e.created_at),
      wer: rot ? '' : (e.user_name || ''),
      detail: verlaufDetail(e, rollenNamen),
      rot,
    };
  });
}
